import { SendGETUserAPI } from "../../customFunctions/Api.js";

export default {
    state: {
        userData: localStorage.getItem("user"),
        apiKey: '',
        accessToken: "",
        authHeaderForServerAPIRequest: {},
        refreshToken: localStorage.getItem('rToken'),
        apiRefreshToken: localStorage.getItem('apiRefreshToken'),
        isLogined: false,
        checkAliveId: null,
        userEmail: '',
        userPassword: '',
        /** When true, Evolve applies Auth0-aligned password policy (User API Auth0:Enabled). */
        auth0PasswordPolicyEnabled: false,
    },
    actions: {
        async fetchAuth0PasswordPolicy({ commit }) {
            try {
                const res = await SendGETUserAPI("config/auth0-enabled", {});
                const enabled =
                    res &&
                    (res.auth0Enabled === true || res.Auth0Enabled === true);
                commit("setAuth0PasswordPolicyEnabledMutation", !!enabled);
            } catch {
                commit("setAuth0PasswordPolicyEnabledMutation", false);
            }
        },
        async setApiKey(ctx, state) {
            if (!state.security.apiKey) {
                const getApiKey = await SendGETUserAPI(
                    "users/" + state.security.userData.id + "/api-key",
                    {
                        Authorization: "Bearer " + state.security.accessToken,
                    }
                );
                ctx.commit('setApiKeyMutation', getApiKey.apiKey)
            }
        }
    },
    mutations: {
        setUserDataMutation(state, values) {
            state.userData = values
        },
        setAccessTokenMutation(state, values) {
            state.accessToken = values
        },
        setAuthHeaderForServerAPIRequestMutation(state, values) {
            state.authHeaderForServerAPIRequest = values
        },
        setRefreshTokenMutation(state, values) {
            state.refreshToken = values
        },
        setIsLoginedMutation(state, values) {
            state.isLogined = values
        },
        setUserEmailMutation(state, values) {
            state.userEmail = values
        },
        setUserPasswordMutation(state, values) {
            state.userPassword = values
        },
        setApiRefreshTokenMutation(state, values) {
            state.apiRefreshToken = values
        },
        setAllSecurityValuesNullMutation(state) {
            state.userData = {},
                state.accessToken = "",
                state.authHeaderForServerAPIRequest = {},
                state.refreshToken = "",
                state.isLogined = false,
                state.apiKey = ""
        },
        setApiKeyMutation(state, values) {
            state.apiKey = values
        },
        setAuth0PasswordPolicyEnabledMutation(state, value) {
            state.auth0PasswordPolicyEnabled = value;
        },
    },
    getters: {
        getUserData(state) {
            return state.userData;
        },
        getAccessToken(state) {
            return state.accessToken;
        },
        getAuthHeaderForServerAPIRequest(state) {
            return state.authHeaderForServerAPIRequest;
        },
        getRefreshToken(state) {
            return state.refreshToken;
        },
        getIsLogined(state) {
            return state.isLogined;
        },
        getCheckAliveId(state) {
            return state.checkAliveId;
        },
        getUserEmail(state) {
            return state.userEmail;
        },
        getUserPassword(state) {
            return state.userPassword;
        },
        getApiRefreshToken(state) {
            return state.apiRefreshToken;
        },
        getApiKey(state) {
            return state.apiKey;
        },
        getAuth0PasswordPolicyEnabled(state) {
            return state.auth0PasswordPolicyEnabled;
        },
    },
}